import styled from 'styled-components';
import sp from 'styled-props';
import { themeGet } from 'styled-system';
import { slideUp } from 'utils/styles/animations';
import theme from 'utils/styles/theme';

import {
	fontFamily,
	textAlign,
	display,
	space,
	lineHeight,
	fontWeight,
	fontSize,
	letterSpacing,
	color,
	left,
	top,
	bottom,
	right
} from 'styled-system';

const Text = styled.div`
   ${fontFamily}
   ${textAlign}
   ${lineHeight}
   ${fontWeight}
   ${letterSpacing}
   ${space}
   ${display}
   ${fontSize}
   ${color}
   ${top}
   ${left}
   ${bottom}
   ${right}
   ${props => props.animated && slideUp};
   text-transform: ${sp(theme.textTransforms)};
   animation-delay: ${props => props.delay && props.delay + 'ms'};

   p {
      line-height: ${themeGet('lineHeights.copy')};
   }

   a {
      font-weight: regular;
      &:hover {
         color: ${themeGet('colors.client.primary')};
      }
   }

   ul {
      margin-left: 0;
   }
   
   li {
      list-style: none;

   }
`;

Text.defaultProps = {
	fontFamily: 'sansSerif',
	lineHeight: 'copy'
};

export default Text;
